import React, { Component } from 'react';
import SumaContexto from '../contexto/SumaContexto';
import { withRouter } from "react-router-dom";
import { Spin, Table, Button, Tooltip } from 'antd';
import { withCookies } from 'react-cookie';
import { ProfileOutlined, EyeOutlined, SearchOutlined } from '@ant-design/icons';
import ServicioUsuarios from '../servicios/usuarios/ServicioUsuarios'
import ServicioSolicitud from '../servicios/ServicioSolicitud'
import ServicioDatosConstantes from '../servicios/ServicioDatosConstantes'
import Utilidades from '../utilidades/Utilidades'
import FiltroColumna from '../general/tabla/FiltroColumna'
import FiltroEtiqueta from '../general/tabla/FiltroEtiqueta'
import Constantes from '../utilidades/Constantes';
import ServicioPersonaJuridica from '../servicios/usuarios/ServicioPersonaJuridica'
//import moment from 'moment';
import _ from 'lodash';


class ListarMisSolicitudes extends Component {

    static contextType = SumaContexto;

    ENUM_COMPONENTE = {
        CARGANDO: 1,
        VER: 2,
        NO_DISPONIBLE: 3,
        ERROR_MOSTRAR_MENSAJE: 4
    }

    state = {
        componente: this.ENUM_COMPONENTE.CARGANDO,
        vistaSolicitudesUsuario: null,
        cargando: false,

        filtro: {},
        filtroEtiquetas: [],
        filtroApi : {},
        paginacion: {
            current: 1,
            pageSize: 10,
            ordenarColumna: 'codigoSolicitud', 
            orden: 'descend'
        },
        cargandoTabla: true
    };

    constructor(props) {
        super(props);
        this.historyLocal = props.history;
        this.callbackVerSolicitud = props.callbackVerSolicitud;

        this.servicioUsuarios = new ServicioUsuarios(props);
        this.servicioPersonaJuridica = new ServicioPersonaJuridica(props);
        this.servicioSolicitud = new ServicioSolicitud(props);
        this.servicioDatosConstantes = new ServicioDatosConstantes(props);

        let contexto = this;
        this.filtroColumna = new FiltroColumna(props, (valores) => { contexto.setSumaState(valores, contexto) });
    }

    componentDidMount() {
        this._isMounted = true;
        this.cargarDatosIniciales();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setSumaState(valores) {
        if (this._isMounted) {
            this.setState(valores);
        }
    }

    // -----------------------------------------------------------------------
    // --- CARGA DATOS INICIALES ---------------------------------------------
    // -----------------------------------------------------------------------
    async cargarDatosIniciales() {
        // Validando que el usuario tenga sesión
        this.setSumaState({ cargando: true, });
        let usr = await this.servicioUsuarios.usuarioEnSesion();
        console.log('usr',usr);
        if (usr !== null) {
            const estados = await this.servicioDatosConstantes.obtenerEstadosSolicitud();
            let estadosSolicitudes = [];
            if (estados) {
                for (let estado of estados) {
                    estadosSolicitudes.push({ label: estado.estadoSolicitud, value: estado.id });
                }
            }
            // Si el usuario es de tipo persona jurídica se hace la respectiva validación
            if( usr.tipoUsuario.id === Constantes.ENUMS.TIPO_USUARIO.PERSONA_JURIDICA.id){
                let usrPj = await this.servicioPersonaJuridica.usuarioValido();
                if( !usrPj.usuarioPersonaJuridica ){
                    console.log('Entra aquí, paila');
                    this.setState({ 
                        cargando: false, 
                        componente: this.ENUM_COMPONENTE.ERROR_MOSTRAR_MENSAJE,
                        mensaje: 'Para habilitar esta sección debes diligenciar y guardar primero los datos de la entidad persona jurídica.'
                    });
                    return;
                }
            }

            await this.cargarDatosTabla(this);
            this.setSumaState({ componente: this.ENUM_COMPONENTE.VER, cargando: false, usuario: usr, estadosSolicitudes: estadosSolicitudes });
        } else {
            this.setSumaState({ componente: this.ENUM_COMPONENTE.NO_DISPONIBLE, cargando: false });
        }
    }


    // 'limpiarFiltro': Método (clearFilters) que es propio de la tabla antDesign para limpiar los filtros
    // 'confirmarFiltro': Método (confirm) que es própio de la tabla antDesign para aplicar el filtro
    // 'dataIndex': Retorna el campo que se está filtrando
    // 'selectedKeys': Retorna el valor a filtrar;
    async cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) {
        let filtro = contexto.state.filtro;
        if (dataIndex !== undefined) { // Si el filtro es aplicado, se agrega la columna filtrada
            filtro[dataIndex] = selectedKeys;
        }
        contexto.setSumaState({ filtro: filtro });
        // Se construye el filtroApi a partir de lo que fue filtrado en la tabla
        let filtroApi = {
            ...(filtro.codigoSolicitud && filtro.codigoSolicitud.length > 0 && { codigoSolicitud: filtro.codigoSolicitud[0] }),
            ...(filtro.codigoSolicitudDependencia && filtro.codigoSolicitudDependencia.length > 0 && { codigoSolicitudDependencia: filtro.codigoSolicitudDependencia[0] }),
            ...(filtro.estadoSolicitud && filtro.estadoSolicitud.length > 0 && filtro.estadoSolicitud[0].opc && { estado: filtro.estadoSolicitud[0].opc.join() }),
            ...(filtro.estadoSolicitud && filtro.estadoSolicitud.length > 0 && filtro.estadoSolicitud[0].texto && { estadoDependencia: filtro.estadoSolicitud[0].texto }),
            ...(filtro.fechaFinalMax && filtro.fechaFinalMax.length > 0 && { fechaFinalMax: filtro.fechaFinalMax[0] + '-' + filtro.fechaFinalMax[1] }),
            ...(filtro.fechaInicialMin && filtro.fechaInicialMin.length > 0 && { fechaInicialMin: filtro.fechaInicialMin[0] + '-' + filtro.fechaInicialMin[1] }),
            ...(filtro.fechaRegistro && filtro.fechaRegistro.length > 0 && { fechaRegistro: filtro.fechaRegistro[0] + '-' + filtro.fechaRegistro[1] }),
            ...(filtro.tipoSolicitud && filtro.tipoSolicitud.length > 0 && { tipoSolicitud: filtro.tipoSolicitud[0] }),
            ...(filtro.usuario && filtro.usuario.length > 0 && { usuario: filtro.usuario[0] })
        };

        const paginacion = this.state.paginacion;
        let paginacionApi = {
            paginaActual:this.state.paginacion.current,
            paginaTamano:this.state.paginacion.pageSize,
            ordenarColumna:this.state.paginacion.ordenarColumna,
            orden: this.state.paginacion.orden
        }

        let cambio = false;
        // Primero valida si hubo cambio a nivel de filtro
        if( !_.isEqual(this.state.filtroApi, filtroApi) ){
            paginacion.current = 1;
            paginacionApi.paginaActual = 1;
            cambio = true;
        }

        // Segundo valida si hubo cambio a nivel de paginación
        if( !cambio && !_.isEqual(this.state.paginacionApi, paginacionApi) ){
            cambio = true;
        }

        if( !cambio ){
            return; // Si no hubo cambio no se hace nada
        }

        contexto.setSumaState({  
            cargandoTabla: true, 
            filtro, 
            filtroApi, 
            paginacionApi, 
            paginacion
        });

        await this.servicioSolicitud.obtenerMisSolicitudes(
            {   
                ...filtroApi,
                ...paginacionApi
            } 
        )
            .then(( tablaPaginada ) => {
                const paginacion = this.state.paginacion;
                paginacion.total = tablaPaginada.total;
                contexto.setSumaState({
                    vistaSolicitudesUsuario: tablaPaginada.registros,
                    cargandoTabla: false,
                    paginacion
                });
            }).then(() => {
                if (limpiarFiltro !== undefined) { limpiarFiltro(); }
                if (confirmarFiltro !== undefined) { confirmarFiltro(); }
            });
    }

    handleTableChange = async (pagination, filters, sorter) => {
        const paginacion = this.state.paginacion;
        paginacion.current = pagination.current;
        paginacion.pageSize = pagination.pageSize;
        paginacion.ordenarColumna = sorter.field;
        paginacion.orden = sorter.order;
        this.setSumaState({  paginacion });
        await this.cargarDatosTabla(this);
    };

    render() {

        const { componente, vistaSolicitudesUsuario, cargando, estadosSolicitudes, usuario, mensaje } = this.state;
        let { filtro } = this.state;
        filtro = filtro || {};
        let contexto = this;

        const columns = [
            {
                title: 'Código',
                align: 'center',
                dataIndex: 'codigoSolicitud',
                key: 'codigoSolicitud',
                width: 60,
                defaultSortOrder: 'descend',
                sorter: (a, b) => 0, //a.codigoSolicitud - b.codigoSolicitud,
                filteredValue: filtro.codigoSolicitud || null,
                ...this.filtroColumna.busquedaTexto(
                    'Código',
                    'codigoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Solicitud',
                align: 'center',
                dataIndex: 'codigoSolicitudDependencia',
                key: 'codigoSolicitudDependencia',
                width: 60,
                sorter: (a, b) =>  0, //a.codigoSolicitudDependencia ? a.codigoSolicitudDependencia.localeCompare(b.codigoSolicitudDependencia) : 1,
                filteredValue: filtro.codigoSolicitudDependencia || null,
                ...this.filtroColumna.busquedaTexto(
                    'Solicitud',
                    'codigoSolicitudDependencia',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
            },
            {
                title: 'Fecha Registro',
                align: 'center',
                dataIndex: 'fechaRegistro',
                key: 'fechaRegistro',
                width: 110,
                sorter: (a, b) => 0, //moment(a.fechaRegistroEstandar, Constantes.FORMATO_FECHA_ESTANDAR) - moment(b.fechaRegistroEstandar, Constantes.FORMATO_FECHA_ESTANDAR),
                filteredValue: filtro.fechaRegistro || null,
                ...this.filtroColumna.busquedaFecha(
                    'Fecha Registro',
                    'fechaRegistro',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            {
                title: 'Ocupación Inicial',
                dataIndex: 'fechaInicialMin',
                align: 'center',
                key: 'fechaInicialMin',
                width: 110,
                sorter: (a, b) => 0, //moment(a.fechaInicialMinEstandar, Constantes.FORMATO_FECHA_ESTANDAR) - moment(b.fechaInicialMinEstandar, Constantes.FORMATO_FECHA_ESTANDAR),
                filteredValue: filtro.fechaInicialMin || null,
                ...this.filtroColumna.busquedaFecha(
                    'Ocupación Inicial',
                    'fechaInicialMin',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['lg'], /* visible en pantalla con ancho ≥ 992px*/
            },
            {
                title: 'Ocupación Final',
                dataIndex: 'fechaFinalMax',
                align: 'center',
                key: 'fechaFinalMax',
                width: 110,
                sorter: (a, b) => 0, //moment(a.fechaFinalMaxEstandar, Constantes.FORMATO_FECHA_ESTANDAR) - moment(b.fechaFinalMaxEstandar, Constantes.FORMATO_FECHA_ESTANDAR),
                filteredValue: filtro.fechaFinalMax || null,
                ...this.filtroColumna.busquedaFecha(
                    'Ocupación Final',
                    'fechaFinalMax',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['lg'], /* visible en pantalla con ancho ≥ 992px*/
            },
            {
                title: 'Actividad',
                dataIndex: 'tipoSolicitud',
                key: 'tipoSolicitud',
                sorter: (a, b) => 0, //a.tipoSolicitud ? a.tipoSolicitud.localeCompare(b.tipoSolicitud) : 1,
                filteredValue: filtro.tipoSolicitud || null,
                ...this.filtroColumna.busquedaTexto(
                    'Actividad',
                    'tipoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['md'], /* visible en pantalla con ancho ≥ 768px*/
            },
            {
                title: 'Estado',
                dataIndex: 'estadoSolicitud',
                key: 'estadoSolicitud',
                sorter: (a, b) => 0, //a.estadoSolicitud ? a.estadoSolicitud.localeCompare(b.estadoSolicitud) : 1,
                filteredValue: filtro.estadoSolicitud || null,
                ...this.filtroColumna.busquedaOpcionesConTexto(
                    'Estado',
                    'estadoSolicitud',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) },
                    estadosSolicitudes
                ),
                render: (text, record) => (
                    <>
                        <span><strong>{text}</strong></span><br />
                        <span>{record.estadoDependencia}</span>
                    </>
                ),
                responsive: ['sm'], /* visible en pantalla con ancho ≥ 576px*/
            },
            ...( usuario && usuario.tipoUsuario.id === Constantes.ENUMS.TIPO_USUARIO.PERSONA_JURIDICA.id ?
            [{
                title: 'Usuario',
                dataIndex: 'usuario',
                key: 'usuario',
                sorter: (a, b) => 0, //a.usuario ? a.usuario.localeCompare(b.usuario) : 1,
                filteredValue: filtro.usuario || null,
                ...this.filtroColumna.busquedaTexto(
                    'Usuario',
                    'usuario',
                    (limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) => { contexto.cargarDatosTabla(contexto, limpiarFiltro, confirmarFiltro, dataIndex, selectedKeys) }
                ),
                responsive: ['md'], /* visible en pantalla con ancho ≥ 768px*/
            }] : []
            ),
            {
                title: 'Opciones',
                key: 'opciones',
                align: 'center',
                className: 'columna-opciones',
                width: 112,
                render: (text, record) => (
                    <>
                        <Tooltip title="Ver solictud">
                            <Button className="boton-opcion-list" shape="circle"
                                icon={<EyeOutlined style={{ 'color': '#c90a00' }} />}
                                onClick={(e) => { contexto.callbackVerSolicitud(e, record.codigoSolicitud) }} />
                        </Tooltip>

                        {Utilidades.opcionesDependenciaSolicitudPorRol(record.opcionesRoles,usuario.rol.id).map((opcionDependenciaSolicitud, index) =>

                            <Tooltip title={opcionDependenciaSolicitud.opcionDependencia} key={index}>
                                <Button className="boton-opcion-list btn-dependencia"
                                    shape="circle"
                                    icon={<Utilidades.IconoAntDesign type={opcionDependenciaSolicitud.icono} />}
                                    style={{ 'color': opcionDependenciaSolicitud.color }}
                                    onMouseOver={(e) => { e.target.style.borderColor = opcionDependenciaSolicitud.color; }}
                                    onMouseLeave={(e) => { e.target.style.borderColor = ""; }}
                                    onClick={(e) => {
                                        Utilidades.onClickRedireccionOpcionDependencia( contexto.servicioSolicitud,record.idSolicitud,opcionDependenciaSolicitud.id );
                                    }}
                                />
                            </Tooltip>
                        )}
                    </>
                ),
            },
        ];

        return (
            <>

                {(componente === this.ENUM_COMPONENTE.VER) ?
                    (
                        <>

                            <div className="titulo-seccion">
                                <label> <ProfileOutlined /> MIS SOLICITUDES</label>
                                <div className="separador-horizontal-completo"></div>
                            </div>

                            <Spin tip="Por favor espera..." size="large" spinning={cargando}>

                                {
                                    this.state.filtroEtiquetas.length > 0 ?
                                        (<div className="seccion-filtros-etiquetas">
                                            <div className="titulo-filtro-etiquetas">
                                                <label>Filtros <SearchOutlined /> :</label>
                                            </div>

                                            {
                                                this.state.filtroEtiquetas.map((filtroEtiqueta, i) => {
                                                    return (
                                                        <FiltroEtiqueta key={i}
                                                            dataIndex={filtroEtiqueta.dataIndex}
                                                            texto={filtroEtiqueta.texto}
                                                            onClose={filtroEtiqueta.borrarFiltro} />
                                                    )
                                                })
                                            }
                                        </div>)
                                        :
                                        (<></>)
                                }

                                <Table columns={columns}
                                    dataSource={vistaSolicitudesUsuario}
                                    className="tabla-comprimida"
                                    onChange={this.handleTableChange}
                                    pagination={this.state.paginacion}
                                    loading={this.state.cargandoTabla}
                                    sortDirections={['ascend', 'descend', 'ascend']}
                                />
                            </Spin>

                        </>
                    )
                    :
                    (
                        (componente === this.ENUM_COMPONENTE.CARGANDO) ?
                            (<Spin tip="Por favor espera..." className="solo-spin-cargando" size="large" />)
                            :(componente === this.ENUM_COMPONENTE.ERROR_MOSTRAR_MENSAJE) ?
                            (<label>{mensaje}</label>)
                            : ((componente === this.ENUM_COMPONENTE.NO_DISPONIBLE) ? (<label>Contenido no disponible. [Cod:LMS]</label>) : (<></>))
                    )
                }
            </>
        );
    }
}

export default withRouter(withCookies(ListarMisSolicitudes));